import React, { useState } from 'react';

const RestrictedTextBox = ({ options, align = 'left', id, value, onChange }) => {
  const [selectedOption, setSelectedOption] = useState(options[0] || '');
  const [isOpen, setIsOpen] = useState(false);

  const handleToggle = () => setIsOpen(!isOpen);

  const handleSelect = (option) => {
    let newValue = option;

    if (option === 'Manual' ) {
    // ask user for value
      const userInput = prompt('Enter value:');
      if (userInput) {
        newValue = userInput
      } else {
      return;
      }
    }

    setSelectedOption(newValue);
    setIsOpen(false);

    if (onChange) {
      onChange(newValue)}
  };

  const containerStyle = {
    position: 'relative',
    width: '100%',
    height: '100%',
    zIndex: 800
  };

  const mainStyle = {
    padding: '2px',
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: align === 'center' ? 'center' : 'flex-start',
    cursor: 'default',
    /* zIndex: 800, */
  };

  const mainHoverStyle = {
    /* backgroundColor: '#f9fafb', */
  };

  const dropdownStyle = {
    position: 'absolute',
    width: '100%',
    backgroundColor: '#fff',
    border: '1px solid #d1d5db',
    zIndex: 20,
    top: '100%',
    left: 0,
    overflowY: 'auto',
    zIndex: 2000,
  };

  const optionStyle = {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: align === 'center' ? 'center' : 'flex-start',
    cursor: 'pointer',
    padding: '4px 0px',
    zIndex: 2000,
  };

  const optionHoverStyle = {
    backgroundColor: '#f3f4f6',
     zIndex: 2000,
  };

  const textStyle = {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
     zIndex: 2000,
  };

  return (
    <div style={containerStyle}>
      <div className='restricted-main'
        style={mainStyle}
        onClick={handleToggle}
        onMouseEnter={(e) => Object.assign(e.currentTarget.style, mainHoverStyle)}
        onMouseLeave={(e) => Object.assign(e.currentTarget.style, mainStyle )}
      >
        <span id={id} style={textStyle}>{value}</span>
      </div>
      {isOpen && (
        <div style={dropdownStyle} className='restricted-dropdown'>
          {options
            // .filter(option => option !== selectedOption)
            .map((option, index) => (
              <div
                className='restricted-dropdown-option'
                key={index}
                style={optionStyle}
                onClick={() => handleSelect(option)}
                onMouseEnter={(e) => Object.assign(e.currentTarget.style, optionHoverStyle)}
                onMouseLeave={(e) => Object.assign(e.currentTarget.style, { backgroundColor: '#fff' })}
              >
                <span style={textStyle}>{option}</span>
              </div>
            ))}
            <div className='restricted-clickable-div' style={optionStyle} onClick={() => handleSelect('Manual')}
                onMouseEnter={(e) => Object.assign(e.currentTarget.style, optionHoverStyle)}
                onMouseLeave={(e) => Object.assign(e.currentTarget.style, { backgroundColor: '#fff' })}
              >
              <span style={textStyle}>Free Text</span>
            </div>
        </div>
      )}
    </div>
  );
};

export default RestrictedTextBox;